import SentimentSatisfiedAltOutlinedIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import SentimentDissatisfiedOutlinedIcon from "@mui/icons-material/SentimentDissatisfiedOutlined";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

export const COMMENT_TYPE_1 = 1;
const COMMENT_TYPE_2 = 2;
const COMMENT_TYPE_3 = 3;
const COMMENT_TYPE_4 = 4;

export const COMMENT_TYPES = [
  {
    value: COMMENT_TYPE_1,
    text: "comments.type1",
    title: "comments.type1Title",
    icon: <SentimentSatisfiedAltOutlinedIcon fontSize="large" />,
  },
  {
    value: COMMENT_TYPE_2,
    text: "comments.type2",
    title: "comments.type2Title",
    icon: <SentimentDissatisfiedOutlinedIcon fontSize="large" />,
  },
  {
    value: COMMENT_TYPE_3,
    text: "comments.type3",
    title: "comments.type3Title",
    icon: <TipsAndUpdatesOutlinedIcon fontSize="large" />,
  },
  {
    value: COMMENT_TYPE_4,
    text: "comments.type4",
    title: "comments.type4Title",
    icon: <WarningAmberOutlinedIcon fontSize="large" />,
  },
];
